export const businessConfig = {
  samNonBuyable: {
    isFreeCarpetSampleEnabled: false
  }
};